const LEUVIORA_HANDLE = 'pure-organics-gymnema-supplement';
const leuvioraPlans = {1:2549186678,3:2690646134,5:2690809974};
const leuvioraOffers = {1:'1284579',3:'1284580',5:'1284581'};
const leuvioraVariant = 43951037907062;
let leuvioraBusy = false;
const leuvioraNativeFetch = window.fetch.bind(window);

async function leuvioraCartRequest(path, data) {
  const response = await leuvioraNativeFetch((window.Shopify?.routes?.root || '/') + path, {
    credentials:'same-origin', headers:{Accept:'application/json',...(data ? {'Content-Type':'application/json'} : {})},
    ...(data ? {method:'POST',body:JSON.stringify(data)} : {})
  });
  const json = await response.json();
  if (!response.ok) throw new Error(json.description || `Cart request failed (${response.status})`);
  return json;
}

function leuvioraBundleItems(quantity, subscribed) {
  if (!quantity) return [];
  const free = quantity === 5 ? 2 : quantity === 3 ? 1 : 0;
  const plan = leuvioraPlans[quantity];
  const properties = {_bundle:'134783',_bundle_offer:leuvioraOffers[quantity],_offer_timestamp:Date.now(),_bundle_use_compare_at:'true'};
  const items = [{id:leuvioraVariant,quantity:quantity-free,properties:{...properties},...(subscribed ? {selling_plan:plan} : {})}];
  if(free) items.push({id:leuvioraVariant,quantity:free,properties:{...properties,_bundle_bxgy_free:'true',...(subscribed ? {_bundle_bxgy_selling_plan:String(plan)} : {})},...(subscribed ? {selling_plan:plan} : {})});
  return items;
}

function leuvioraShowCart() {
  if(location.pathname.replace(/\/$/,'').endsWith('/cart')) {location.reload(); return;}
  const event = new Event('shopify:cart:lines-update',{bubbles:true});
  Object.defineProperty(event,'promise',{value:Promise.resolve({detail:{}})});
  document.dispatchEvent(event);
  setTimeout(() => window.Shopify?.actions?.openCart?.(),250);
}

function leuvioraCartError(message) {
  let notice = document.getElementById('leuviora-cart-message');
  if(!notice) {
    notice = document.createElement('p'); notice.id='leuviora-cart-message'; notice.setAttribute('role','alert');
    notice.style.cssText='padding:12px;color:#8c2222;background:#fff4f4';
    (document.querySelector('#cart-drawer') || document.body).append(notice);
  }
  notice.textContent=message;
}

async function leuvioraSetBundle(quantity, trigger) {
  if(leuvioraBusy || ![0,1,3,5].includes(quantity)) return;
  leuvioraBusy=true;
  if(trigger) {trigger.setAttribute('aria-busy','true'); trigger.disabled=true;}
  let backup=[];
  let removed=false;
  const groupPlan=trigger?.closest('tr[data-leuviora-paid]')?.dataset.leuvioraPlan;
  const inGroup=item=>item.variant_id===leuvioraVariant && (groupPlan===undefined || Number(item.selling_plan_allocation?.selling_plan.id || 0)===Number(groupPlan));
  let resultPlan;
  try {
    const cart=await leuvioraCartRequest('cart.js');
    const lines=cart.items.filter(inGroup);
    const paid=lines.filter(item=>item.final_line_price>0);
    const modes=new Set(paid.map(item=>Boolean(item.selling_plan_allocation)));
    if(modes.size>1 && quantity!==0) throw new Error('Your cart contains both one-time and subscription bottles. Remove this group and choose the offer you want to change.');
    const subscribed=paid.some(item=>item.selling_plan_allocation);
    resultPlan=subscribed ? leuvioraPlans[quantity] : 0;
    if(quantity && groupPlan!==undefined && cart.items.some(item=>item.variant_id===leuvioraVariant && !inGroup(item) && Number(item.selling_plan_allocation?.selling_plan.id || 0)===resultPlan)) throw new Error('That delivery schedule is already in your cart. Please adjust its existing offer separately.');
    backup=lines.map(item=>({id:item.variant_id,quantity:item.quantity,properties:item.properties,...(item.selling_plan_allocation ? {selling_plan:item.selling_plan_allocation.selling_plan.id} : {})}));
    await leuvioraCartRequest('cart/update.js',{updates:Object.fromEntries(lines.map(item=>[item.key,0]))});
    removed=true;
    const items=leuvioraBundleItems(quantity,subscribed);
    if(items.length) await leuvioraCartRequest('cart/add.js',{items});
    const result=await leuvioraCartRequest('cart.js');
    const changed=result.items.filter(item=>item.variant_id===leuvioraVariant && Number(item.selling_plan_allocation?.selling_plan.id || 0)===(quantity ? resultPlan : Number(groupPlan || 0)));
    if(changed.reduce((n,item)=>n+item.quantity,0)!==quantity) throw new Error('The bottle count could not be verified.');
    if(changed.some(item=>subscribed ? item.selling_plan_allocation?.selling_plan.id!==leuvioraPlans[quantity] : Boolean(item.selling_plan_allocation))) throw new Error('The delivery interval could not be verified.');
    const expectedFree=quantity===5 ? 2 : quantity===3 ? 1 : 0;
    const freeCount=changed.filter(item=>item.final_line_price===0).reduce((sum,item)=>sum+item.quantity,0);
    if(freeCount!==expectedFree) throw new Error('The free bottle discount could not be verified. Your previous bundle has been restored.');
    document.getElementById('leuviora-cart-message')?.remove();
    leuvioraShowCart();
  } catch(error) {
    if(removed) {
      try {
        const cart=await leuvioraCartRequest('cart.js');
        const lines=cart.items.filter(item=>inGroup(item) || (item.variant_id===leuvioraVariant && Number(item.selling_plan_allocation?.selling_plan.id || 0)===resultPlan));
        await leuvioraCartRequest('cart/update.js',{updates:Object.fromEntries(lines.map(item=>[item.key,0]))});
        if(backup.length) await leuvioraCartRequest('cart/add.js',{items:backup});
        leuvioraShowCart();
      } catch(restoreError) {leuvioraCartError('Please refresh and review your cart before checking out.'); return;}
    }
    leuvioraCartError(error.message);
  } finally {
    leuvioraBusy=false;
    if(trigger) {trigger.removeAttribute('aria-busy'); trigger.disabled=false;}
  }
}

document.addEventListener('quantity-selector:update',event=>{
  const row=event.target instanceof Element ? event.target.closest('tr[data-leuviora-paid]') : null;
  if(!row) return;
  event.stopPropagation();
  if(leuvioraBusy) return;
  const current=Number(row.dataset.leuvioraTotalQuantity || 1);
  const requested=Number(event.detail?.quantity);
  if(!Number.isFinite(requested)) return;
  const quantity=requested<=0 ? 0 : requested>current ? (current<3 ? 3 : 5) : requested<current ? (current>3 ? 3 : 1) : current;
  const input=row.querySelector('cart-quantity-selector-component input');
  if(input) input.value=String(quantity);
  if(quantity!==current) leuvioraSetBundle(quantity,row.querySelector('cart-quantity-selector-component'));
},true);

document.addEventListener('click',event=>{
  if(leuvioraBusy && event.target.closest('[name="checkout"], .leuviora-upgrade-five, .leuviora-remove-bundle, cart-quantity-selector-component')) {event.preventDefault(); event.stopImmediatePropagation(); return;}
  const remove=event.target.closest('.leuviora-remove-bundle');
  const upgrade=event.target.closest('.leuviora-upgrade-five');
  if(remove || upgrade) {event.preventDefault(); leuvioraSetBundle(remove ? 0 : 5,remove || upgrade);}
},true);

async function hydrateUpgradeCards() {
  const cards=[...document.querySelectorAll('.leuviora-upgrade')].filter(el=>!el.dataset.pricingState);
  if(!cards.length) return;
  cards.forEach(el=>el.dataset.pricingState='loading');
  try {
    const [cart,product]=await Promise.all([leuvioraCartRequest('cart.js'),leuvioraCartRequest(`products/${LEUVIORA_HANDLE}.js`)]);
    const variant=product.variants.find(item=>item.id===leuvioraVariant);
    const lines=cart.items.filter(item=>item.variant_id===leuvioraVariant);
    const quantity=lines.reduce((n,item)=>n+item.quantity,0);
    const current=lines.reduce((n,item)=>n+item.final_line_price,0);
    const subscribed=lines.some(item=>item.final_line_price>0 && item.selling_plan_allocation);
    const allocation=variant.selling_plan_allocations?.find(item=>item.selling_plan_id===leuvioraPlans[5]);
    const target=(subscribed ? (allocation?.price ?? Math.round(variant.price*0.75)) : variant.price)*3;
    const compare=(variant.compare_at_price || variant.price)*5;
    const money=value=>new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:cart.currency}).format(value/100);
    const set=(card,selector,value)=>{const el=card.querySelector(selector); if(el) el.textContent=value;};
    for(const card of cards) {
      set(card,'[data-atlas-target-total]',money(target));
      set(card,'[data-atlas-target-compare]',money(compare));
      set(card,'[data-atlas-target-savings]',`Save ${Math.round((1-target/compare)*100)}%`);
      set(card,'[data-atlas-target-per-bottle]',money(Math.round(target/5)));
      set(card,'[data-atlas-per-bottle-savings]',money(Math.max(0,Math.round(current/quantity-target/5))));
      set(card,'[data-atlas-bottles-added]',`${Math.max(0,5-quantity)} bottles`);
      set(card,'[data-atlas-additional-cost]',money(Math.max(0,target-current)));
      const loading=card.querySelector('.leuviora-atlas-loading'); if(loading) loading.hidden=true;
      const grid=card.querySelector('.leuviora-atlas-price-grid'); if(grid) grid.hidden=false;
      const button=card.querySelector('.leuviora-upgrade-five'); if(button) button.disabled=false;
      card.dataset.pricingState='ready';
    }
  } catch(error) {cards.forEach(card=>{card.dataset.pricingState='error'; const button=card.querySelector('.leuviora-upgrade-five'); if(button) button.disabled=false;});}
}

(() => {
  const variant = 43951037907062;
  const plans = { 1: 2549186678, 3: 2690646134, 5: 2690809974 };
  const originalFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let syncing = false;
  let pricing = null;
  const selection = () => {
    const offer = document.querySelector('.bundle-qty-deal__radio[data-bundle="134783"]:checked');
    return { quantity: Number(offer?.value || 1), subscribed: Boolean(document.querySelector('#atlas-bundler-subscription-checkbox')?.checked) };
  };
  const sync = () => {
    if (syncing) return;
    const offer = document.querySelector('.bundle-qty-deal__radio[data-bundle="134783"]:checked');
    if (!offer) return;
    syncing = true;
    try {
      const state = selection();
      const selector = document.querySelector('#atlas-bundler-subscription-dropdown-frequency');
      const option = selector?.querySelector(`[role="option"][data-value="${plans[state.quantity]}"]`);
      if (option && option.getAttribute('aria-selected') !== 'true') option.click();
      for (const text of document.querySelectorAll('.atlas-subscription-card .label-subtitle')) {
        text.textContent = `${state.quantity} ${state.quantity === 1 ? 'bottle delivered every month' : `bottles delivered every ${state.quantity} months`}`;
      }
      if(selector) selector.style.display='none';
      const info=document.querySelector('.atlas-subscription-card .label-addition-info');
      if(info) info.style.height='auto';
      if(pricing) {
        const money=value=>new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:pricing.currency,currencyDisplay:'narrowSymbol'}).format(value/100);
        const set=(el,value)=>{if(el && el.textContent!==value) el.textContent=value;};
        for(const radio of document.querySelectorAll('.bundle-qty-deal__radio[data-bundle="134783"]')) {
          const quantity=Number(radio.value);
          const paid=quantity===5 ? 3 : quantity===3 ? 2 : 1;
          const allocation=pricing.variant.selling_plan_allocations?.find(item=>item.selling_plan_id===plans[quantity]);
          const unit=state.subscribed ? (allocation?.price ?? Math.round(pricing.variant.price*0.75)) : pricing.variant.price;
          const total=unit*paid;
          const compare=(pricing.variant.compare_at_price || pricing.variant.price)*quantity;
          const savings=`You Save ${Math.round((1-total/compare)*100)}%`;
          const label=radio.parentElement.querySelector('.bundle-qty-option');
          set(label?.querySelector('.discounted-price'),money(total));
          set(label?.querySelector('.compare-price'),money(compare));
          set(label?.querySelector('.bundle-qty-subtitle-text'),savings);
          const card=document.querySelector(`[data-bundle-card][data-bundle-index="${quantity===1 ? 0 : quantity===3 ? 1 : 2}"]`);
          set(card?.querySelector('[data-bundle-price]'),money(total));
          set(card?.querySelector('[data-bundle-compare]'),money(compare));
          set(card?.querySelector('[data-bundle-saving]'),savings);
          if(quantity===1 || quantity===3 || quantity===5) {
            for(const container of [label?.querySelector('.bundle-radio-info-subtitle-container'),card]) {
              if(!container || container.querySelector('.leuviora-bundle-shipping-note')) continue;
              const note=document.createElement('p');
              note.className='leuviora-bundle-shipping-note';
              note.textContent='✓ Free shipping included';
              note.style.cssText='margin:6px 0 0;font-size:13px;font-weight:600;line-height:1.4;color:#174f3b';
              if(container===card) container.querySelector('[data-bundle-button]')?.before(note);
              else {note.style.marginLeft='29px'; container.append(note);}
            }
          }
        }
      }
    } finally { syncing = false; }
  };
  window.fetch = function(input, options) {
    const url = typeof input === 'string' ? input : input?.url || String(input);
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && typeof options?.body === 'string') {
      try {
        const payload = JSON.parse(options.body);
        const items = payload.items || [payload];
        if (document.querySelector('.bundle-qty-deal__radio[data-bundle="134783"]') && items.some(item => Number(item.id) === variant)) {
          const state = selection();
          for (const item of items) {
            if (Number(item.id) !== variant) continue;
            if (state.subscribed) {
              item.selling_plan = plans[state.quantity];
              if(item.properties?._bundle_bxgy_free) item.properties._bundle_bxgy_selling_plan=String(plans[state.quantity]);
            } else {
              delete item.selling_plan;
              if(item.properties) delete item.properties._bundle_bxgy_selling_plan;
            }
          }
          options = {...options, body:JSON.stringify(payload)};
        }
      } catch (error) { console.warn('Leuviora subscription request', error); }
    }
    return originalFetch(input, options);
  };
  document.addEventListener('change', event => {
    if (event.target.matches('.bundle-qty-deal__radio, #atlas-bundler-subscription-checkbox')) {
      sync();
      requestAnimationFrame(sync);
      setTimeout(sync,250);
    }
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('#my-add-to-cart-button')) sync();
  }, true);
  async function api(path, data) {
    const response = await originalFetch(root + path, {
      credentials:'same-origin',
      headers:{Accept:'application/json', ...(data ? {'Content-Type':'application/json'} : {})},
      ...(data ? {method:'POST',body:JSON.stringify(data)} : {})
    });
    const value = await response.json();
    if (!response.ok) throw new Error(value.description || `Cart error ${response.status}`);
    return value;
  }
  function mount() {
    sync();
    if(document.querySelector('.bundle-qty-deal__radio[data-bundle="134783"]') || location.pathname.includes('pure-organics-gymnema-supplement')) {
      Promise.all([api('products/pure-organics-gymnema-supplement.js'),api('cart.js')]).then(([product,cart])=>{
        pricing={variant:product.variants.find(item=>item.id===variant),currency:cart.currency};
        sync();
      }).catch(error=>console.warn('Bundle pricing unavailable',error));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  const observer = new MutationObserver(() => {
    if(document.querySelector('.bundle-qty-deal__radio[data-bundle="134783"]')) { sync(); observer.disconnect(); }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
